import React from "react";
import {
  PageHeader,
  Divider,
  Row,
  Col,
} from "antd";

import { EXPORT_ICON } from "@constants/IconsConstants";

import Pesticides from "./pesticides";
import Fertilizers from "./fertilizers";

function Export() {
  return (
    <>
      <PageHeader title="Exportar" avatar={{ src: EXPORT_ICON }} />

      <Divider orientation="left">O que deseja exportar?</Divider>

      <br />

      <Row gutter={16}>
        <Col span={8}>
          <Pesticides />
        </Col>
        <Col span={8}>
          <Fertilizers />
        </Col>
      </Row>
    </>
  );
}

export default Export;
